import { InputIconColor } from "enums/Input";
import ReactDatePicker from "react-datepicker";
import styled from "styled-components";
import { Field, Label } from "styles/formStyles";
import { FIELD_HEIGHT } from "styles/sizes";
import Icon from "../Icon/Icon";
import arrow from "../Icon/icons/arrow.svg";
import Tooltip from "../Tooltip/Tooltip";
import "react-datepicker/dist/react-datepicker.css";

export const DatePickerLabel = styled(Label)`
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker {
    border: none;
    border-radius: 2px;
    filter: drop-shadow(0 1px 6px ${(props) => props.theme.shadowColor});
    overflow: hidden;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__navigation--previous,
  .react-datepicker__navigation--next {
    border: none;
    height: 13px;
    width: 13px;
    top: 10px;
    background-color: ${(props) => props.theme.surface};
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: cover;
    -webkit-mask-image: url("${arrow}");
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: cover;
    mask-image: url("${arrow}");
    transition: -webkit-mask-image 0.3s ease-in-out;
  }

  .react-datepicker__navigation--next {
    transform: rotate(180deg);
  }

  .react-datepicker__navigation-icon::before {
    display: none;
  }

  .react-datepicker__navigation--previous:hover,
  .react-datepicker__navigation--next:hover {
    opacity: 0.75;
  }

  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: ${(props) => props.theme.buttonFilledText};
  }

  .react-datepicker__day {
    border-radius: 2px !important;
  }

  .react-datepicker__header {
    background-color: ${(props) => props.theme.primary};
    border-bottom: none;
  }

  .react-datepicker__day--outside-month {
    color: ${(props) => props.theme.black50};
  }

  .react-datepicker__day--in-selecting-range {
    color: ${(props) => props.theme.black50} !important;
    background-color: ${(props) => props.theme.primaryPale} !important;
  }

  .react-datepicker__day--in-range {
    color: ${(props) => props.theme.black};
    background-color: ${(props) => props.theme.primaryPale};
  }

  .react-datepicker__day--keyboard-selected {
    background-color: ${(props) => props.theme.primary} !important;
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__day--selected,
  .react-datepicker__day.react-datepicker__day--selected:hover {
    color: ${(props) => props.theme.buttonFilledText};
    background-color: ${(props) => props.theme.primary};
  }

  .react-datepicker__day:hover {
    color: ${(props) => props.theme.buttonFilledText};
    background-color: ${(props) => props.theme.primary05};
  }
`;

export const DatePickerField = styled(ReactDatePicker)`
  ${Field}
  text-align: center;
`;

interface InputIconProps {
  color: InputIconColor;
}

export const InputIcon = styled(Icon)<InputIconProps>`
  background-color: ${({ theme, color }) => theme[color]};
`;

// Centres the 20px icon in the field's height.
export const IconWrapper = styled.div`
  padding: ${(FIELD_HEIGHT - 20) / 2}px;
  cursor: pointer;
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  bottom: 0;
  height: ${FIELD_HEIGHT}px;
  width: ${FIELD_HEIGHT}px;
`;

export const CustomTooltip = styled(Tooltip)`
  .Popover-body {
    max-width: 250px;
    text-align: center;
  }
`;
